/**
 * /arena/:gym_code/board — Arena Board TV display.
 * No login required. Auto-updates every 30 seconds.
 */
import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { apiClient } from "../../services/api";

export default function ArenaBoardTV() {
  const { code: gym_code } = useParams();
  const [data, setData] = useState(null);
  const [now, setNow] = useState(new Date());

  const load = useCallback(() => {
    apiClient.get(`/arena/${gym_code}/board`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [gym_code]);
  useEffect(() => {
    load();
    const id = setInterval(load, 30_000);
    return () => clearInterval(id);
  }, [load]);
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!data) return <div style={{ minHeight: "100vh", background: "#0C0C0B", color: "white", display: "grid", placeItems: "center" }}>Loading…</div>;

  return (
    <div style={{ minHeight: "100vh", background: "#0C0C0B", color: "white", overflow: "hidden", fontFamily: "Barlow, sans-serif", display: "flex", flexDirection: "column" }} data-testid="arena-board-tv">
      <header style={{ display: "flex", alignItems: "center", padding: "20px 32px", borderBottom: "1px solid rgba(245,197,24,0.45)" }}>
        <img src="/assets/arena/fitfrik-shield.jpg" alt="" width={32} height={32} style={{ borderRadius: "50%" }} />
        <div style={{ flex: 1, textAlign: "center", fontFamily: "Barlow Condensed", fontSize: 32, fontWeight: 900 }}>
          {data.gym.gym_name} <span style={{ color: "#F5C518" }}>Arena</span>
        </div>
        <div style={{ fontFamily: "Barlow Condensed", fontSize: 24, fontWeight: 800 }}>
          {now.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: false })}
        </div>
      </header>

      <main style={{ flex: 1, padding: 32, display: "flex", flexDirection: "column" }}>
        <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 4 }}>
          {(data.leaderboard || []).map((row, i) => (
            <LeaderboardRow key={row._id || i} row={row} rank={i + 1} />
          ))}
          {data.leaderboard?.length === 0 && (
            <div style={{ textAlign: "center", color: "rgba(255,255,255,0.6)", fontSize: 24, marginTop: 80 }}>
              No check-ins this week yet — be the first!
            </div>
          )}
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderTop: "1px solid rgba(255,255,255,0.10)" }}>
          <span style={{ fontSize: 14, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.16em", color: "rgba(255,255,255,0.40)" }}>
            THIS WEEK · {data.metric_label}
          </span>
          <span style={{ fontSize: 12, color: "rgba(255,255,255,0.40)" }}>Resets Monday</span>
        </div>
      </main>

      <footer style={{ background: "rgba(245,197,24,0.08)", borderTop: "1px solid rgba(245,197,24,0.30)", padding: "12px 0", overflow: "hidden" }}>
        <div style={{ display: "flex", whiteSpace: "nowrap", animation: "ticker 50s linear infinite" }}>
          {[...(data.ticker || []), ...(data.ticker || [])].map((t, i) => (
            <span key={i} style={{ padding: "0 32px", color: "#F5C518", fontSize: 16, fontWeight: 600 }}>
              ✦ {t.user_name || "Member"} just checked in
            </span>
          ))}
        </div>
      </footer>

      <style>{`@keyframes ticker { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }`}</style>
    </div>
  );
}

function LeaderboardRow({ row, rank }) {
  const colors = { 1: "#F5C518", 2: "#C0C0C0", 3: "#CD7F32" };
  const color = colors[rank] || "white";
  const fontSize = rank === 1 ? 40 : rank <= 3 ? 32 : 22;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 20, padding: "8px 16px", borderLeft: rank <= 3 ? `4px solid ${color}` : "4px solid transparent", background: rank % 2 === 0 ? "rgba(255,255,255,0.03)" : "transparent" }}>
      <div style={{ fontFamily: "Barlow Condensed", fontSize, fontWeight: 900, color, minWidth: 60 }}>#{rank}</div>
      {row.avatar ? (
        <img src={row.avatar} alt="" width={48} height={48} style={{ borderRadius: "50%", objectFit: "cover" }} />
      ) : (
        <div style={{ width: 48, height: 48, borderRadius: "50%", background: "rgba(255,255,255,0.10)", display: "grid", placeItems: "center", fontSize: 22, fontWeight: 800 }}>
          {(row.name || "?").slice(0, 1).toUpperCase()}
        </div>
      )}
      <div style={{ flex: 1, fontSize: rank === 1 ? 28 : 20, fontWeight: rank <= 3 ? 800 : 600, color: rank <= 3 ? color : "white" }}>{row.name || "Member"}</div>
      <div style={{ fontFamily: "Barlow Condensed", fontSize: rank === 1 ? 36 : 24, fontWeight: 900, color }}>{row.count || row.score || 0}</div>
    </div>
  );
}
